<div class="sc-nav-panel-mobile">
  <div *ngFor="let item of panel.items" class="sc-nav-panel-item" [attr.title]="item.label" (click)="itemClicked.emit(item)">
    <a
      (click)="item.isOpen = !item.isOpen"
      class="sc-nav-panel-item__link"
    >
      <sc-icon
        *ngIf="item.icon"
        class="sc-nav-panel-item__icon"
        [icon]="item.icon" size="0_75"></sc-icon>
      <span
        *ngIf="!item.icon"
        class="sc-nav-panel-item__icon-placeholder">
      </span>
      <div class="sc-nav-items__list-item-label">
        {{item.label}}
      </div>
    </a>
  </div>
</div>
<div class="sc-nav-panel-desktop">
  <div class="sc-nav-panel__list">
    <div *ngFor="let item of panel.items" class="sc-nav-panel__list-item" [attr.title]="!showTooltip ? item.label : ''" >
      <a
      (click)="itemClicked.emit(item)"
        class="sc-nav-panel__list-item-link"
        [attr.id]="item.id"
        [tooltip]="showTooltip ? item.tooltip : null"
        [delay]="60"
        placement="right"
        container="body"
        triggers="hover click"
      >
        <sc-icon
          *ngIf="item.icon"
          class="sc-nav-panel__list-item-icon"
          [icon]="item.icon"
          [size]="item.size"></sc-icon>
      </a>
    </div>
  </div>
</div>
